import { Box, Grid, Paper, Typography } from '@mui/material';
import ReportingKpiCards from '../analytics/ReportingKpiCards';
import ReportingTrendChart from '../analytics/ReportingTrendChart';
import ReportingCtaTable from '../analytics/ReportingCtaTable';
import ReportingFailuresTable from '../analytics/ReportingFailuresTable';
import MessagePreview from './MessagePreview';
import { useTemplateDetailsContext } from '../../context/TemplateDetailsContext';

export default function TemplatePerformancePanel() {
  const {
    isOrgMode,
    overview,
    graphData,
    buttonEngagement,
    failureRows,
    isLoading,
    hasChartData,
    usingReportingPipeline,
  } = useTemplateDetailsContext();

  return (
    <Box sx={{ pt: 2 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={isOrgMode ? 12 : 8}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Performance Overview
            </Typography>
            <ReportingKpiCards overview={overview} isLoading={isLoading} showRates={usingReportingPipeline} />
            {hasChartData ? <ReportingTrendChart graphData={graphData} /> : null}
          </Paper>
        </Grid>

        {!isOrgMode ? (
          <Grid item xs={12} lg={4}>
            <Paper sx={{ p: 2, borderRadius: 2, height: '100%' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                Message Preview
              </Typography>
              <MessagePreview />
            </Paper>
          </Grid>
        ) : null}

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Button Engagement
            </Typography>
            <ReportingCtaTable
              rows={buttonEngagement}
              isLoading={isLoading}
              mode={isOrgMode ? 'org' : 'template'}
            />
          </Paper>
        </Grid>

        {usingReportingPipeline ? (
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                Failures
              </Typography>
              <ReportingFailuresTable
                rows={failureRows}
                isLoading={isLoading}
                showAffectedTemplates={isOrgMode}
              />
            </Paper>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
}
